import { useState } from 'react';
import { DataExplorerThreadList } from '../components/data-explorer/DataExplorerThreadList';
import { DataExplorerChat } from '../components/data-explorer/DataExplorerChat';
import { useCompany } from '../contexts/CompanyContext';

export default function DataExplorerPage() {
  const { selectedCompanies, addCompany, removeCompany } = useCompany();
  const [activeThreadId, setActiveThreadId] = useState(null);
  const [refreshThreads, setRefreshThreads] = useState(0);

  return (
    <div className="flex h-full bg-white">
      <DataExplorerThreadList
        activeThreadId={activeThreadId}
        onSelectThread={setActiveThreadId}
        onNewChat={() => setActiveThreadId(null)}
        refreshKey={refreshThreads}
      />
      <DataExplorerChat
        threadId={activeThreadId}
        selectedCompanies={selectedCompanies}
        onSelectCompany={addCompany}
        onRemoveCompany={removeCompany}
        onThreadCreated={(tid) => { setActiveThreadId(tid); setRefreshThreads(r => r + 1); }}
      />
    </div>
  );
}
